import * as yup from 'yup';

import { AdminSettingsResponse } from '../../../types';

import {
  transformAdminSettingsToFormValues,
  transformAdminSettingsToRequestValues
} from '../../../utils';

import { ADMIN_SETTINGS_GROUP } from 'RestAPIs/endpoints';
import { useSaveResource } from 'RestAPIs/useSaveResource';

import { useGetAdminSettings } from '../../../../queries';
import { AdminSettingsFormWrapper } from 'components/shared/AdminSettings/AdminSettingsFormWrapper';
import { FormContent } from './components/FormContent';

export const SETTINGS_GROUP_NAME = 'import-travel-arrangement';

const schema = yup.object({
  import_travel_import_arrangement_type: yup.string().default(''),
  import_travel_arrangement_filePath: yup.string().default(''),
  import_travel_arrangement_compensationTypeId: yup
    .string()
    .required()
    .default(''),
  import_travel_arrangement_trvSetId: yup.string().default(''),
  import_travel_arrangement_countryCode: yup.string().default(''),
  import_travel_arrangement_contractKindToKeep: yup.string().default('')
});

export const ImportTravelArrangement = () => {
  const { data: importTravelArrangement = [], isFetching } =
    useGetAdminSettings<AdminSettingsResponse>(SETTINGS_GROUP_NAME);

  const { isLoading, mutate: save } = useSaveResource({
    url: ADMIN_SETTINGS_GROUP,
    id: importTravelArrangement[0]?.groupId,
    invalidateQueryKey: [SETTINGS_GROUP_NAME]
  });

  const settings = importTravelArrangement[0] ?? undefined;

  const onSubmit = (data) => {
    const payload = {
      ...settings,
      settings: transformAdminSettingsToRequestValues(data, settings?.settings)
    };
    save(payload);
  };

  return (
    <AdminSettingsFormWrapper
      submitForm={onSubmit}
      schema={schema}
      isFetching={isFetching}
      isLoading={isLoading}
      data={transformAdminSettingsToFormValues(settings)}
    >
      <FormContent />
    </AdminSettingsFormWrapper>
  );
};
